module.exports = __webpack_public_path__ + "static/media/maritimo_hidrogeno.bcdcf27b.PNG";